import { analytics } from "./analytics";
const MESSAGE_SOURCE = "deal3dp-calculator";
const SERVER_TRACKED = new Set([
    "spec_viewed",
    "model_downloaded",
    "project_saved",
    "lead_submitted",
    "share_clicked",
]);
const SERVER_SKIP = new Set(['configurator_params_changed']); // что НЕ шлём на сервер
export function createServerAdapter(api) {
    return {
        name: "Server",
        track(event) {
            if (SERVER_SKIP.has(event.name))
                return; // режем только шум
            api.track(event.name, event.params ?? undefined);
        },
    };
}
export function createPostMessageAdapter({ calculatorId, calculatorType }) {
    return {
        name: "PostMessage",
        track(event) {
            if (typeof window === "undefined")
                return;
            // в iframe parent !== self; при прямом заходе parent === self и слушать некому
            window.parent.postMessage({
                source: MESSAGE_SOURCE,
                calculatorId,
                calculatorType,
                name: event.name,
                params: event.params ?? {},
            }, "*" // целевой origin неизвестен (разные клиенты); payload без приватных данных
            );
        },
    };
}
let heartbeatTimer = null;
function startHeartbeat(api, intervalMs = 15000) {
    if (typeof window === 'undefined')
        return;
    if (heartbeatTimer) {
        return;
    }
    let activeSinceLastBeat = false;
    const markActive = () => { activeSinceLastBeat = true; };
    const events = ['mousemove', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'keydown', 'wheel'];
    events.forEach(e => window.addEventListener(e, markActive, { passive: true }));
    heartbeatTimer = setInterval(() => {
        if (document.visibilityState !== 'visible')
            return;
        if (!activeSinceLastBeat)
            return;
        activeSinceLastBeat = false;
        api.track('heartbeat');
    }, intervalMs);
}
export function initAnalyticsGA(options) {
    if (analytics.isInitialized())
        return;
    analytics.markInitialized();
    analytics.register(createPostMessageAdapter({
        calculatorId: options.calculatorId,
        calculatorType: options.calculatorType,
    }));
    if (options.api) {
        analytics.register(createServerAdapter(options.api));
        startHeartbeat(options.api);
    }
}
